import React, { useState } from 'react';
import { Button, Card, Col, Container, Dropdown, DropdownButton, Row} from "react-bootstrap";
import { axiosAuth_PLATFORM_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';


const AppAdminNewAppView = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);


  // Initialize with actual JSON obj.  If not, will get error.
  const [uiAppAttrs, setUiAppAttrs] = useState({
    name: '',
    description: '',
    interface: '',
    product: ''
  });

  // ##### Enhancement: Fetch through API or config. #####

  const interfaceOptions = [
    { key: "WEB",    value: "WEB" },
    { key: "MOBILE", value: "MOBILE" }
  ];

  const productOptions = [
    { key: "BuildingOS", value: "BuildingOS" }
  ];


/*
  // Initialize state
  useEffect(() => {
  }, [props]);
*/


  // Ui Functions

  const [errMsg, setErrMsg] = useState('');


  const onAttrsInputChange = (e) => {
    setUiAppAttrs({ ...uiAppAttrs, [e.target.name]: e.target.value })
  }

  const onInterfaceSelect = (key, event) => {
    setUiAppAttrs({ ...uiAppAttrs, interface: key })
  };

  const onProductSelect = (key, event) => {
    setUiAppAttrs({ ...uiAppAttrs, product: key })
  };


  const handleSubmit = (e) => {
    e.preventDefault();

    if (!uiAppAttrs.name || uiAppAttrs.name.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_uiApp_name"));
    } else if (uiAppAttrs.name.length > 100) {
      setErrMsg(t("I18N_ERR_Max_len_name") + "100");
    } else {
      validateName();
    }

    return;
  }

  // Since this is async, need to call this first, and check the others when name availability returns
  function validateName() {

    new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.get("ui-apps?name=" + uiAppAttrs.name);

        resolve(res.data);

        if (res.data.length > 0) {
          setErrMsg(t("I18N_ERR_uiapp_name_taken"));
        } else {
          validateOtherFields();
        }

      } catch (error) {

        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }

        return;
      }
    });
  }

  function validateOtherFields() {
    // Validate form inputs
    if (!uiAppAttrs.description || uiAppAttrs.description.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_description"));
      return;
    } else if (uiAppAttrs.description.length > 250) {
      setErrMsg(t("I18N_ERR_Max_len_desc") + 250);
      return;
    } else if (uiAppAttrs.interface === '') {
      setErrMsg(t("I18N_ERR_Need_interface"));
      return;
    } else if (uiAppAttrs.interface.length > 20) {
      setErrMsg(t("I18N_ERR_Max_len_interface") + 20);
      return;
    } else if (uiAppAttrs.product === '') {
      setErrMsg(t("I18N_ERR_Need_product"));
      return;
    } else if (uiAppAttrs.product.length > 20) {
      setErrMsg(t("I18N_ERR_Max_len_product") + 20);
      return;
    } else {
      setErrMsg('');
      createNewUiApp();
    }
  }

  const createNewUiApp = () => {

    // Make a deep copy
    const reqBody = JSON.parse(JSON.stringify(uiAppAttrs));

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.post("ui-apps", reqBody);

        resolve(res.data);

        if (res.status === 201) {

          // Return to list
          props.onUIMode('LIST')
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }


  const handleCancel = (e) => {
    e.preventDefault();

    // Return to list
    props.onUIMode('LIST')
  }


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_New_UiApp")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_UiApp_info")}
            </span>
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>
        </div>

        <Container>
          <form>
            <Row className={classes.admin_pages__field_label}>
              <Col>{t("I18N_UiApp_name")}: *</Col>
              <Col>{t("I18N_Description")}: *</Col>
              <Col>{t("I18N_UiApp_Interface_type")}: *</Col>
              <Col>{t("I18N_Product")}: *</Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col>
                <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="name"
                       value={uiAppAttrs.name} onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col>
                <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%'}}  name="description"
                          value={uiAppAttrs.description} onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col>
                <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                  title={!uiAppAttrs.interface ? t("common:I18N_DROPDOWN_PROMPT") :
                          t("I18N_" + (interfaceOptions.find( ({ key }) => key === uiAppAttrs.interface )).value) }
                  onSelect={onInterfaceSelect}>
                  {interfaceOptions.map((item, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                        {t("I18N_" + item.value)}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </Col>
              <Col>
                <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                  title={!uiAppAttrs.product ? t("common:I18N_DROPDOWN_PROMPT") :
                          (productOptions.find( ({ key }) => key === uiAppAttrs.product )).value}
                  onSelect={onProductSelect}>
                  {productOptions.map((item, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                        {item.value}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </Col>
            </Row>

            <hr className="solid" style={{ marginTop: '30px' }}></hr>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px', fontStyle: 'italic' }}>
              <span>{t("I18N_Req_fields")}</span>
            </Row>

            <Row>
              <div display='flex' style={{ marginTop: '15px' }}>
                <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{ float: 'left' }}
                  onClick={handleCancel}>
                  {t("I18N_Cancel")}
                </Button>
                <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{ marginLeft: '15px' }}
                  onClick={handleSubmit}>
                  {t("I18N_Submit")}
                </Button>
                <span className={classes.admin_pages__field_label} style={{ marginLeft: '30px', color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
                  {errMsg}
                </span>
              </div>
            </Row>
          </form>
        </Container>

      </Card>
    </>
  );
}
 
export default AppAdminNewAppView;
